// Used in creating tokens for <AdCompanion />
const generateAdToken = (): string =>
  `${Math.floor(Math.random() * (Math.pow(2, 53) - 1)).toString(
    36
  )}-${new Date().getTime().toString(36)}`;

export default generateAdToken;
